<script setup>
import { nextTick, ref } from 'vue';
import { watchArray } from '@vueuse/core';

import AsyncCombobox from '@/Components/AsyncCombobox.vue';

const props = defineProps({
    modelValue: {
        type: [Array],
        default: () => [],
    },
    selected: {
        type: Array,
        default: () => [],
    },
    maxSelection: {
        type: Number,
        default: null,
    },
});

const emit = defineEmits(['update:modelValue']);

const selectedCustomers = ref(props.selected);
watchArray(selectedCustomers, (value, oldValue) => {
    if (props.maxSelection !== null && value.length > props.maxSelection) {
        selectedCustomers.value = oldValue;
        return;
    }

    emit(
        'update:modelValue',
        value.map((item) => item.number),
    );
});
const customerTitle = (item) => {
    return item.number + ' - ' + item.name;
};
const customFilter = (itemTitle, queryText, item) => {
    const fields = ['number', 'name'];
    return fields.some((field) => {
        return item.raw[field].toLowerCase().includes(queryText.toLowerCase());
    });
};

const combobox = ref(null);
const reset = function () {
    selectedCustomers.value = props.selected;
    nextTick(combobox.value.reset);
};

defineExpose({
    reset,
});
</script>

<template>
    <AsyncCombobox
        ref="combobox"
        v-model="selectedCustomers"
        :label="$t('Customers')"
        filter-column="search"
        item-value="number"
        :item-title="customerTitle"
        :custom-filter="customFilter"
        :search-url="route('api.maillog.customer.index')"
    ></AsyncCombobox>
</template>

<style scoped></style>
